/**
 * Constants for limits of inputs are set here.
 * Suburb names do not have a min as there exists really short suburb names.
 * Fields without a min do have to be double clicked on to be successfully checked.
 */
export const POSTCODE_LENGTH = 4;
export const DISTANCE_MIN = 1;
export const DISTANCE_MAX = 4;
export const ADDRESS_LINE_MAX = 250;
export const ADDRESS_LINE_MIN = 3;
export const SUBURB_MAX = 100;
export const PHONE_MIN = 8;
export const PHONE_MAX = 14;
export const NAME_MIN = 1;
export const NAME_MAX = 250;
export const PASSWORD_MIN = 6;
export const PASSWORD_MAX = 128;
export const ORGANISATION_MIN = 5;
export const ORGANISATION_MAX = 250;
